// src/services/api/shopItemApi.js

/**
 * Shop Item API methods
 * @param {Object} api - axios instance
 * @returns {Object} shop item API methods
 */
const shopItemApi = (api) => {
  return {
    /**
     * Fetch paginated shop items data
     * @param {number} page - page number
     * @param {number} pageSize - items per page
     * @param {string} searchTerm - search term
     * @returns {Promise} response data
     */
    fetchData: async (page = 1, pageSize = 10, searchTerm = "") => {
      try {
        const response = await api.get("/ShopItemImageDetails/Paginated", {
          params: { page, pageSize, searchTerm },
        });
        return response.data;
      } catch (error) {
        throw new Error(
          error.response?.data?.message || "Failed to fetch data"
        );
      }
    },

    /**
     * Add a new shop item
     * @param {FormData} formData - item data with image
     * @returns {Promise} response data
     */
    addItem: async (formData) => {
      try {
        const response = await api.post("/ShopItemImageDetails", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        return response.data;
      } catch (error) {
        throw new Error(error.response?.data?.message || "Failed to add item");
      }
    },

    /**
     * Update an existing shop item
     * @param {number|string} id - item id
     * @param {FormData} formData - updated item data
     * @returns {Promise} response data
     */
    updateItem: async (id, formData) => {
      try {
        const response = await api.put(
          `/ShopItemImageDetails/${id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        return response.data;
      } catch (error) {
        throw new Error(
          error.response?.data?.message || "Failed to update item"
        );
      }
    },

    /**
     * Delete a shop item
     * @param {number|string} id - item id
     * @returns {Promise} response data
     */
    deleteItem: async (id) => {
      try {
        const response = await api.delete(`/ShopItemImageDetails/${id}`);
        return response.data;
      } catch (error) {
        throw new Error(
          error.response?.data?.message || "Failed to delete item"
        );
      }
    },

    /**
     * Fetch a shop item by id
     * @param {number|string} id - item id
     * @returns {Promise} response data
     */
    fetchItemById: async (id) => {
      try {
        const response = await api.get(`/ShopItemImageDetails/${id}`);
        return response.data;
      } catch (error) {
        throw new Error(
          error.response?.data?.message || "Failed to fetch item details"
        );
      }
    },
  };
};

export default shopItemApi;
